import apiClient from './client';
import type {
  DailyDataResponse,
  ClickRateResponse,
  MonthlySummaryResponse,
  LabelGroupRatesResponse,
} from '@/types/data';

export interface DailyDataParams {
  company_id: number;
  start_date: string;
  end_date: string;
  account_ids?: number[];
  label_ids?: number[];
  include_cumulative?: boolean;
}

export interface ClickRateParams {
  company_id: number;
  start_date: string;
  end_date: string;
}

export interface LabelGroupRatesParams {
  company_id: number;
  start_date: string;
  end_date: string;
  account_ids?: number[];
  aggregation_type?: 'total' | 'daily';
}

export interface MonthlySummaryParams {
  company_id: number;
  year: number;
  month: number;
}

export interface AvailableMonth {
  year: number;
  month: number;
  value: string;  // "YYYY-MM" format
}

export interface AvailableMonthsResponse {
  company_id: number;
  months: AvailableMonth[];
}

export const dataApi = {
  // 日次データ取得
  getDailyData: async (params: DailyDataParams): Promise<DailyDataResponse> => {
    const response = await apiClient.get<DailyDataResponse>('/api/data/daily', { params });
    return response.data;
  },

  // クリック率データ取得
  getClickRateData: async (params: ClickRateParams): Promise<ClickRateResponse> => {
    const response = await apiClient.get<ClickRateResponse>('/api/data/click-rate', { params });
    return response.data;
  },

  // ラベルグループ別レート取得
  getLabelGroupRates: async (params: LabelGroupRatesParams): Promise<LabelGroupRatesResponse> => {
    const response = await apiClient.get<LabelGroupRatesResponse>('/api/data/label-group-rates', { params });
    return response.data;
  },

  // 月次サマリー取得
  getMonthlySummary: async (params: MonthlySummaryParams): Promise<MonthlySummaryResponse> => {
    const response = await apiClient.get<MonthlySummaryResponse>('/api/data/monthly-summary', { params });
    return response.data;
  },

  // データが存在する年月の一覧を取得
  getAvailableMonths: async (company_id: number): Promise<AvailableMonthsResponse> => {
    const response = await apiClient.get<AvailableMonthsResponse>('/api/data/available-months', {
      params: { company_id }
    });
    return response.data;
  },
};
